// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7956dcfc","239":"9fdf0051","453":"68459f2b","732":"ed35b7c2"}[chunkId] + ".chunk.js";
};